import React from 'react';
import { useTheme } from '../../context/ThemeContext';

export function Logo() {
  const { theme } = useTheme();
  const logoSrc = theme === 'light' ? '/icons/logo-light.png' : '/icons/logo.png';

  return (
    <div className="flex items-center gap-1.5 font-headline">
      <img src={logoSrc} alt="222fasting" className="h-8 w-auto" />
      <span className="text-xl font-bold text-on-surface">FASTING</span>
    </div>
  );
}
